/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface RequisitionDetail {
  id: string
  code: string
  currencyAmount: number
  exchangeRate: number
  description: string
  expiresAt: string
  finalRialAmount: number
  initialRialAmount: number
  commissionRialAmount: number
  status: string
  type: 'BUY' | 'SELL'
  availableForOffer: boolean
  totalOffers: number
  isOld: boolean
  createdAt: string
  currency: {
    id: string
    titleFa: string
    titleEn: string
    isoCode: string
  }
  country: {
    id: string
    title: {
      fa: string
      en: string
    }
    callingCode: number
    flagUrl?: string
    iso?: string
    availability?: {
      registration: boolean
      transaction: boolean
    }
  }
  owner: {
    id: string
    uuid: string
    fullName: string
  }
  transferMethods: Array<{
    id: string
    title: string
    label: string
  }>
  bankAccounts: {
    sellerBank: any | null
    buyerInternationalBank?: {
      type: string
      id: string
      ibanNumber: string
    } | null
    buyerInternationalPaypalBank?: any | null
    buyerInternationalRevolutBank?: any | null
    buyerIranianSourceBank?: any | null
  }
  bankAccountCountries?: {
    seller: any | null
    internationalBuyer?: {
      id: string
      title: {
        fa: string
        en: string
      }
      callingCode: number
      flagUrl: string
      iso: string
      availability: {
        registration: boolean
        transaction: boolean
      }
    } | null
    internationalPaypalBuyer?: any | null
    internationalRevolutBuyer?: any | null
  }
  latestViewerOffer: any | null
  discount: any | null
}

export function getRequisitionDetailAction(requisitionId: string): Promise<ApiResponse<RequisitionDetail>> {
  return api.get<ApiResponse<RequisitionDetail>>(`/requisitions/${requisitionId}`)
}
